<template>
  <confirmation-modal />
  <NotificationComponent />
  <NavbarComponent v-if="$route.name !== 'SignIn'" />
  <router-view />
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<script>
import NavbarComponent from "@/components/shared/NavbarComponent";
import ConfirmationModal from "@/components/shared/ConfirmationModal";
import { mapActions, mapGetters } from "vuex";
import NotificationComponent from "@/components/shared/NotificationComponent";

export default {
  components: { NotificationComponent, ConfirmationModal, NavbarComponent },
  data() {
    return {
      intervalId: null,
    };
  },
  computed: {
    ...mapGetters("auth", ["isAuthenticated", "isAuthenticated"]),
  },
  methods: {
    ...mapActions("auth", ["tokenSignIn"]),
    async checkTokenAndHandleRedirect() {
      if (await this.tokenSignIn()) {
        this.$router.push("/signIn");
      }
    },
  },
  mounted() {
    this.intervalId = setInterval(
      () => this.checkTokenAndHandleRedirect(),
      30000
    );
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
};
</script>
